(function () {
  var storageKey = 'theme:recently-viewed-product-handles';
  var activeTab = 'cart';
  var productCache = {};

  function getDrawer() {
    return document.getElementById('cart-drawer');
  }

  function getHandles() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '[]').filter(Boolean).slice(0, 8);
    } catch (error) {
      return [];
    }
  }

  function formatMoney(cents) {
    var format = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);

    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = fetch(Shopify.routes.root + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product fetch failed');
      return response.json();
    }).catch(function () {
      return null;
    });

    return productCache[handle];
  }

  function getAvailableVariant(product) {
    var variants = product.variants || [];

    for (var i = 0; i < variants.length; i++) {
      if (variants[i].available) return variants[i];
    }

    return variants[0] || null;
  }

  function renderProduct(product) {
    var url = Shopify.routes.root + 'products/' + product.handle;
    var image = product.featured_image || product.images && product.images[0];
    var imageUrl = image ? image + (image.indexOf('?') === -1 ? '?width=160' : '&width=160') : '';
    var variant = getAvailableVariant(product);
    var variantTitle = variant && variant.public_title && variant.public_title !== 'Default Title' ? variant.public_title : '';
    var compareAtPrice = product.compare_at_price && product.compare_at_price > product.price ? product.compare_at_price : 0;
    var addButton = variant && variant.available ? '<button type="button" class="button button--sm button--subdued cart-recently-viewed-add-button" data-cart-recently-viewed-add="' + variant.id + '">+ Add to cart</button>' : '';

    return [
      '<div class="line-item cart-recently-viewed-item">',
        imageUrl ? '<a class="line-item__media-wrapper" href="' + url + '"><img class="line-item__media rounded-xs" loading="lazy" src="' + imageUrl + '" alt="' + escapeHtml(product.title) + '"></a>' : '',
        '<div class="line-item__info">',
          '<div class="v-stack gap-0.5">',
            '<a href="' + url + '" class="bold"><span class="reversed-link hover:show">' + escapeHtml(product.title) + '</span></a>',
            '<div class="price-list">',
              compareAtPrice ? '<sale-price class="text-on-sale">' + formatMoney(product.price) + '</sale-price><compare-at-price class="text-subdued line-through">' + formatMoney(compareAtPrice) + '</compare-at-price>' : '<sale-price>' + formatMoney(product.price) + '</sale-price>',
            '</div>',
          '</div>',
          variantTitle ? '<p class="text-sm text-subdued">' + escapeHtml(variantTitle) + '</p>' : '',
        '</div>',
        '<div class="line-item__actions text-subdued cart-recently-viewed-actions">' + addButton + '</div>',
      '</div>'
    ].join('');
  }

  function renderRecentlyViewed(drawer) {
    var list = drawer.querySelector('[data-cart-recently-viewed-list]');
    var empty = drawer.querySelector('[data-cart-recently-viewed-empty]');
    var handles = getHandles();

    if (!list || !empty) return;

    if (handles.length === 0) {
      list.innerHTML = '';
      empty.hidden = false;
      return;
    }

    list.innerHTML = '';
    empty.hidden = false;
    list.setAttribute('aria-busy', 'true');

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      products = products.filter(Boolean);
      list.innerHTML = products.map(function (product) {
        return renderProduct(product);
      }).join('');
      empty.hidden = products.length > 0;
    }).finally(function () {
      list.removeAttribute('aria-busy');
    });
  }

  function setActiveTab(tab) {
    var drawer = getDrawer();
    if (!drawer) return;

    activeTab = tab;

    drawer.querySelectorAll('[data-cart-drawer-tab]').forEach(function (button) {
      var selected = button.getAttribute('data-cart-drawer-tab') === tab;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-selected', selected ? 'true' : 'false');
    });

    drawer.querySelectorAll('[data-cart-drawer-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-cart-drawer-panel') !== tab;
    });

    var footer = drawer.querySelector('[slot="footer"]');
    if (footer) footer.hidden = tab !== 'cart';

    if (tab === 'recently-viewed') {
      renderRecentlyViewed(drawer);
    }
  }

  function addVariantToCart(button) {
    var variantId = button.getAttribute('data-cart-recently-viewed-add');
    if (!variantId || button.hasAttribute('aria-busy')) return;

    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    var formData = new FormData();
    formData.set('id', variantId);
    formData.set('quantity', '1');
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', Shopify.routes.root + 'variants/' + variantId);

    button.setAttribute('aria-busy', 'true');

    fetch(Shopify.routes.root + 'cart/add.js', {
      body: formData,
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) throw json;
        return json;
      });
    }).then(function (responseJson) {
      return fetch(Shopify.routes.root + 'cart.js').then(function (response) {
        return response.json();
      }).then(function (cart) {
        cart.sections = responseJson.sections || {};
        setActiveTab('cart');

        document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
          bubbles: true,
          detail: {
            items: responseJson.items || [responseJson],
            cart: cart
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            cart: cart
          }
        }));

        window.setTimeout(function () {
          setActiveTab('cart');
        }, 80);
      });
    }).catch(function (error) {
      if (window.console && window.console.warn) {
        window.console.warn('[cart-recently-viewed] add failed', error);
      }
    }).finally(function () {
      button.removeAttribute('aria-busy');
    });
  }

  function handleTabActivation(event) {
    var tab = event.target.closest && event.target.closest('[data-cart-drawer-tab]');
    if (!tab) return;

    event.preventDefault();
    event.stopPropagation();
    setActiveTab(tab.getAttribute('data-cart-drawer-tab'));
  }

  document.addEventListener('click', handleTabActivation, true);

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cart-recently-viewed-add]');
    if (!button) return;

    event.preventDefault();
    addVariantToCart(button);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    handleTabActivation(event);
  }, true);

  document.addEventListener('cart:refresh', function () {
    window.setTimeout(function () {
      setActiveTab(activeTab);
    }, 100);
  });

  document.addEventListener('cart:change', function () {
    window.setTimeout(function () {
      setActiveTab(activeTab);
    }, 1400);
  });

  window.addEventListener('pageshow', function () {
    var drawer = getDrawer();
    if (drawer) renderRecentlyViewed(drawer);
  });
})();
